export default {
  title: 'PGA.com',
  description: "The PGA of America is one of the world's largest sports organizations, composed of PGA of America Golf Professionals who work daily to grow interest and participation in the game of golf.",
  canonical: 'https://www.pga.com/',
}
